import { Form, Input, Tooltip } from "antd";
import React, { useEffect } from "react";
import ComponentLabel from "../../ControlComponents/ComponentLabel";
import { Col, Row } from "react-bootstrap";
import { Controller, useWatch } from "react-hook-form";
import { TableInputProps } from "../TableComponent/TableComponent";
import useMasterSetting from "../../../hooks/useMasterSetting";

type InputFormProps = {
  template: any;
  data: any;
  rowIdx: number;
  colIdx: number;
  col?: any;
  colText?: number;
  colAction?: number;
  name: string;
  control: any;
  canEditDoc: boolean;
  checkActionPage: string;
  buttonType: string;
  onControlChange: (
    controlTemplate: any,
    controlValue: any,
    oldControlValue: any
  ) => any;
};

export const AutoNumber: React.FC<InputFormProps> = ({
  colIdx,
  rowIdx,
  control,
  name,
  data,
  template,
  col,
  colAction,
  colText,
  canEditDoc,
  checkActionPage,
  buttonType,
  onControlChange,
  ...props
}) => {
  const { masterSetting } = useMasterSetting();
  // const masterAutoNumberWordCountAndMessage = masterSetting["autoNumberWordCountAndMessage"];
  // const splitData = data?.value?.split(template.symbol);
  // const removedLastIndex = splitData?.slice(0, -1);
  // const finalData = removedLastIndex?.join(template.symbol) + template.symbol;

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (value) => {
          // เช็คตอน submit หรือ draft และต้องไม่เป็นค่าว่าง
          if (
            (buttonType === "submit" || buttonType === "draft") &&
            (value === "" || value === null || value === undefined)
          ) {
            return `${template.label}`;
          }
          return true;
        },
      }}
      render={({ field, formState: { errors, isSubmitted } }) => {

        const hasError =
          errors?.items &&
          errors?.items[rowIdx] &&
          errors?.items[rowIdx].layout &&
          errors?.items[rowIdx].layout[colIdx];

        return (
          <>
            <ComponentLabel
              // renderInTable={props.renderInTable}
              col={col}
              colText={colText}
              rowIdx={rowIdx}
              colIdx={rowIdx}
              template={template}
            />
            <Col
              sm={col === undefined ? 12 : 12}
              md={col === undefined ? colAction : 12}
              xs={col === undefined ? 12 : 12}
              xl={col === undefined ? colAction : 12}
              className={"padding-controller"}
            >
              <div
                className={`input-component-container ${
                  hasError ? "set-layout-required" : ""
                }`}
              >
                <Input
                  {...field}
                  onBlur={(e) => {
                    field.onChange(e);
                    onControlChange(template, e.target.value, data);
                  }}
                  id={template.label.replaceAll(" ", "_")}
                  value={field.value ? field.value : undefined}
                  readOnly={!canEditDoc || template.attribute.readonly === "Y"}
                  size={"large"}
                  className="input-component"
                  placeholder={
                    template.type !== "an"
                      ? template.attribute.description
                      : "Auto Number"
                  }
                  maxLength={
                    parseInt(template.attribute.length) === 0
                      ? undefined
                      : parseInt(template.attribute.length)
                  }
                  // defaultValue={template.attribute.default}
                  disabled={
                    !canEditDoc ||
                    template.attribute.readonly === "Y" ||
                    template.type === "an"
                  }
                  // onBlur={(e) => onChange(e.target.value)}
                  status={hasError && "error"}
                />

                {hasError && (
                  <small id="Name-help" className="p-error p-d-block">
                    {template.label} is required.
                  </small>
                )}
                
                {/* {masterAutoNumberWordCountAndMessage &&
                  finalData?.length >= Number(masterAutoNumberWordCountAndMessage.Value1) && (
                    <small id="Name-help" className="p-error p-d-block">
                      {masterAutoNumberWordCountAndMessage.Value2 || "จำนวนคำ Prefix เกินจำนวนที่จำกัด"}
                    </small>
                  )
                } */}
              </div>
            </Col>
          </>
        );
      }}
    />
  );
};
// export default InputControlComponent;
